/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\HolderStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 16th 2023, 10:31:31 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const HolderStyled = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
border-radius: 0.3rem;
box-shadow:
0.2rem 0.2rem 0.1rem 0.1rem rgba(0, 0, 0, 0.044),
0.4rem 0.4rem 0.5rem 0.1rem rgba(0, 0, 0, 0.066),
1rem 1rem 1.5rem 0.4rem rgba(0, 0, 0, 0.11);
outline: 1px solid ${(props: any) => getThemeColor(props.bgColor)};

.titleEquipment{
    text-decoration: underline 1px ${(props: any) => getThemeColor(props.bgColor)};
}
`;

export default HolderStyled;
